<utc-product-card [product]="productCard"></utc-product-card>
